export const ID_DEBIT_NOTE ='DEBIT_NOTE';
export const ID_CREDIT_NOTE = 'CREDIT_NOTE';
export const ID_INVOICE = 'INVOICE';
export const ID_ASSISTED_DEBIT_NOTE = 'ASSISTED_DEBIT_NOTE';